// extracted by mini-css-extract-plugin
export default {"component":"StylingWithCSSModules_component__Afivb"};